import { WebParameterContext,WebResponesContext} from '../model/common';
import { AppPageElement} from '../model/xmlconfig/app.page.element';
import * as allFun from './business/base';
/**
 * 提交数据到数据库之前拦截事件，返回拦截结果
 * @param element 当前element节点
 * @param webContext 请求参数
 */
export function HandleWebParameterContextBeforeDBRequest(webParameterContext:WebParameterContext):WebParameterContext
{
     console.log(222);
    if(webParameterContext.Client.PageName && webParameterContext.ConfigName){
        try{
            let fun = new allFun["Services"+webParameterContext.Client.PageName]();
            if(!!fun.HandleWebParameterContextBeforeDBRequest){
                webParameterContext = fun.HandleWebParameterContextBeforeDBRequest(webParameterContext);
            }
        }catch{

        }
    }
    return webParameterContext;
}
/**
 * 参数请求成功返回之后结果集在处理完成返回
 * @param element 当前element节点
 * @param webParameterContext 请求参数
 * @param webContext 返回结果集
 */
export function HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext
{
    if(webParameterContext.Client.PageName && webParameterContext.ConfigName){
        try{
            let fun = new allFun["Services"+webParameterContext.Client.PageName]();
            if(!!fun.HandleServerContextAfterDBRequest){
                webContext = fun.HandleServerContextAfterDBRequest(webParameterContext,webContext);
            }
        }catch{

        }
    }
    return webContext;
}
/**
 * 针对form表单主键值变化时处理
 * @param element 当前element节点名称
 * @param webParameterContext 当前xml名称
 */
export function ControlChanageValue(element:AppPageElement,webParameterContext:WebParameterContext){

}

/**
 * 
 * @param webContext 列表当前行输入值改变
 * @param ConfigName 当前xml名称
 */
export function ContextBeforeChangeValue(webContext:any,ConfigName:string):any{
    if(webContext && ConfigName){
        try{
            let fun = new allFun["Services"+ConfigName]();
            if(!!fun.ContextBeforeChangeValue){
                webContext = fun.ContextBeforeChangeValue(webContext,ConfigName);
            }
        }catch{

        }
    }
    return webContext;
}